import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { standardCommand, CommandBase } from '../../../core/model/command';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { StandardCommandHandlerResolver } from '../../../core/service/command/standard-command-handler-resolver.service';
import { DeleteCommandHandler } from '../../../core/service/command/delete-command-handler.service';
import { DeleteCommandHandlerV2 } from '../../../core/service/command/delete-command-handler.v2.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { ActivatedRoute } from '@angular/router';
import { RentalObjectDocument } from '../../model/rental-object-document';
import { RentalObjectDocumentService } from '../../service/data/rental-object-document.service';
import { ConnectedDocumentManagerComponent } from '../../../common/component/connected-document-manager/connected-document-manager.component';

@Component({
    selector: 'app-rental-object-document-manager',
    templateUrl: '../../../common/component/connected-document-manager/connected-document-manager.component.html',
    providers: [NavigationService, StandardCommandHandlerResolver, { provide: DeleteCommandHandler, useClass: DeleteCommandHandlerV2 }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RentalObjectDocumentManagerComponent extends ConnectedDocumentManagerComponent<RentalObjectDocument> {
  @Input() rentalObjectId?: string;
  @Output() countChange = new EventEmitter<number>();
  constructor(
    activatedRoute: ActivatedRoute,
    dataService: RentalObjectDocumentService,
    nativeWindow: NativeWindowService,
    cdf: ColumnDefinitionFactory,
    commandHandlerResolver: StandardCommandHandlerResolver,
    dispatcher: CommandDispatcher
  ) {
    super(activatedRoute, dataService, nativeWindow, cdf, commandHandlerResolver, dispatcher);
  }

  protected get objectIdParameterName(): string {
    return 'rentalObjectId';
  }

  execute(command: CommandBase): void {
    super.execute(command);
  }

  ngOnInit() {
    if (this.rentalObjectId) {
      this.AddSubscription(
        this._dataService.getByOwnerId(String(this.rentalObjectId)).subscribe(res => {
          this.items = res;
          this.countChange.emit(this.items.length ?? 0);
        })
      );
    } else {
      this.AddSubscription(
        this._activatedRoute.paramMap
          .pipe(
            switchMap(map => {
              let id = map.get(this.objectIdParameterName);
              if (id) {
                return this._dataService.getByOwnerId(id);
              }
              return of([]);
            })
          )
          .subscribe(res => {
            this.items = res as RentalObjectDocument[];
            this.countChange.emit(this.items.length ?? 0);
          })
      );
    }
  }

  protected executedWithResult(result: boolean, command: CommandBase): void {
    if (result && command && command.id === standardCommand.delete) {
      const len = this.items?.length ?? 0;
      this.countChange.emit(len);
    }
  }

  public refresh(): void {
    if (this.rentalObjectId) {
      this.AddSubscription(
        this._dataService.getByOwnerId(String(this.rentalObjectId)).subscribe(res => {
          this.items = res;
          this.countChange.emit(this.items?.length ?? 0);
        })
      );
      return;
    }
    this.AddSubscription(
      this._activatedRoute.paramMap
        .pipe(
          switchMap(map => {
            let id = map.get(this.objectIdParameterName);
            if (id) {
              return this._dataService.getByOwnerId(id);
            }
            return of([]);
          })
        )
        .subscribe(res => {
          this.items = res as RentalObjectDocument[];
          this.countChange.emit(this.items?.length ?? 0);
        })
    );
  }
}
